import { useDispatch, useSelector } from "react-redux";
import ModalDialog from "../../../components/modal/ModalDialog";
import "./AddStay.scss";
import { useEffect, useState, useMemo } from "react";
import {
  GROUP_ROUTE_PATH,
  STAY_SUMMERY_DEFAULT_TABLE_PAYLOAD,
} from "../../../utils/config";
import { Button } from "react-bootstrap";
import {
  fetchLinkedStayDetails,
  linkStayDetailsReducer,
} from "../../../store/feature/staysummary/staySummarySlice";
import {
  ARRIVAL_DATE_LINK_STAY_LABEL,
  CANCEL_BTN_LABEL_LINK_STAY,
  CONFO_LINK_STAY_LABEL,
  CONTINUE_BTN_LABEL_LINK_STAY,
  GUEST_NAME_LINK_STAY_LABEL,
  LINK_STAY_MSG,
  ROOM_NIGHTS_LINK_STAY_LABEL,
} from "../../../utils/constants";
import { formatDate } from "../../../utils/utils";
import { useLocation } from "react-router-dom";
import SortIcon from "../../../components/SortIcon"

export default function LinkedStayModel({
  modalShow,
  closeLinkStay,
  editRow,
  stayBatchDetail,
  continueEditCallback,
}) {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const isGroupBlock = pathname.includes(GROUP_ROUTE_PATH);
  const { linkStayDetails } = useSelector((state) => state.staySummary);
  const [radioSequenceNumber, setRadioSequenceNumber] = useState(
    editRow.sequenceNumber
  );
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  useEffect(() => {
    if (editRow) {
      dispatch(
        fetchLinkedStayDetails({
          payloadForStayTable: {
            ...STAY_SUMMERY_DEFAULT_TABLE_PAYLOAD,
            filterBy: {
              ...STAY_SUMMERY_DEFAULT_TABLE_PAYLOAD.filterBy,
              confoNumber: editRow.confirmationNumber,
            },
            batchNum1: stayBatchDetail.batchNum1,
            batchNum2: stayBatchDetail.batchNum2,
            group: isGroupBlock,
            editStay: true,
          },
          propertyCode: stayBatchDetail.propertyCode,
        })
      );
    }
    return () => {
      dispatch(linkStayDetailsReducer({}));
    };
  }, [editRow]);

  const onOptionChange = (e) => {
    setRadioSequenceNumber(e.target.value);
  };

  const onContinueAction = () => {
    const selectedStay = linkStayDetails.find(
      (stay) => stay.sequenceNumber === radioSequenceNumber
    );
    if (continueEditCallback && selectedStay) {
      continueEditCallback({
        ...selectedStay,
        enableEdit: true,
        enableSave: false,
      });
    }
    closeLinkStay();
  };
  const onCancelAction = () => {
    closeLinkStay();
  };

  const sortedData = useMemo(() => {
    if (!sortConfig.key) return linkStayDetails;

    const sorted = [...linkStayDetails].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === 'asc' ? -1 : 1;
      if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });

    return sorted;
  }, [linkStayDetails, sortConfig]);

  const sortedColumn = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    else if (sortConfig.key === key && sortConfig.direction === 'desc') {
      direction = null;
    }
    if (direction === null) {
      setSortConfig({ key: null, direction: null });
      return;
    }
    setSortConfig({ key, direction });
  };

  const sortOrder = {
    asc: <SortIcon sortBy="asc"></SortIcon>,
    desc: <SortIcon sortBy="desc"></SortIcon>
  };

  return (
    <ModalDialog
      show={modalShow}
      handleOnShowClose={closeLinkStay}
      ariaLabelledby="contained-modal-title-vcenter"
      className={`linked-stay-overlay`}
      size={"lg"}
    >
      <div className="linked-stay">
        <h4 className="weight-700">{"Linked Stays"}</h4>
      </div>
      <p className="mt-3">{LINK_STAY_MSG}</p>
      <div className="data-table-server">
        <table className="linked-stay-table">
          <tr>
            <th style={{ width: "30px" }}></th>
            <th
              style={{ width: "200px", cursor: "pointer" }}
            >
              {GUEST_NAME_LINK_STAY_LABEL}
              <span
                style={{ cursor: "pointer", marginLeft: "6px" }}
                onClick={() => sortedColumn("guestName")}
              >

                {
                  (sortConfig.key === "guestName") ?
                    (sortConfig.direction === "asc" ? sortOrder.asc : (sortConfig.direction === "desc") ? sortOrder.desc : <SortIcon />)
                    : <SortIcon />
                }
              </span>
            </th>
            <th
              style={{ width: "80px", cursor: "pointer" }} >

              {CONFO_LINK_STAY_LABEL}
              <span
                style={{ cursor: "pointer", marginLeft: "6px" }}
                onClick={() => sortedColumn("confirmationNumber")}
              >
                {
                  (sortConfig.key === "confirmationNumber") ?
                    (sortConfig.direction === "asc" ? sortOrder.asc : (sortConfig.direction === "desc") ? sortOrder.desc : <SortIcon />)
                    : <SortIcon />
                }
              </span>
            </th>
            <th
              style={{ width: "100px", cursor: "pointer" }} >

              {ARRIVAL_DATE_LINK_STAY_LABEL}
              <span
                style={{ cursor: "pointer", marginLeft: "6px" }}
                onClick={() => sortedColumn("arrivalDate")}
              >
                {
                  (sortConfig.key === "arrivalDate") ?
                    (sortConfig.direction === "asc" ? sortOrder.asc : (sortConfig.direction === "desc") ? sortOrder.desc : <SortIcon />)
                    : <SortIcon />
                }
              </span>
            </th>
            <th style={{ width: "110px" }}>{ROOM_NIGHTS_LINK_STAY_LABEL}</th>
          </tr>

          {sortedData?.length &&
            sortedData.map((stay) => (
              <tr>
                <td>
                  <input
                    type="radio"
                    name="selectedLinkedStay"
                    checked={stay.sequenceNumber === radioSequenceNumber}
                    value={stay.sequenceNumber}
                    onChange={onOptionChange}
                  />
                </td>
                <td>{stay.guestName}</td>
                <td>{stay.confirmationNumber}</td>
                <td>{formatDate(stay.arrivalDate, "DDMMMYY").toUpperCase()}</td>
                <td>{stay.roomNights}</td>
              </tr>
            ))}
        </table>
      </div>
      <div className={"flex-box-row flex-align-center mt-4"}>
        <Button variant={"primary"} onClick={onContinueAction}>
          {CONTINUE_BTN_LABEL_LINK_STAY}
        </Button>
        <Button
          variant="link"
          className="text-decoration-none"
          onClick={onCancelAction}
        >
          {CANCEL_BTN_LABEL_LINK_STAY}
        </Button>
      </div>
    </ModalDialog>
  );
}
